import { render, staticRenderFns } from "./FavoriteStore.vue?vue&type=template&id=646e2b90&scoped=true"
import script from "./FavoriteStore.vue?vue&type=script&lang=js"
export * from "./FavoriteStore.vue?vue&type=script&lang=js"
import style0 from "./FavoriteStore.vue?vue&type=style&index=0&id=646e2b90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646e2b90",
  null
  
)

export default component.exports